
import { 
    TERME_ACCUMULATEUR_KO_import_payoffInfo, 
    TERME_ACCUMULATEUR_KO_export_payoffInfo 
} from "src/shared/Cotation/describe/TermeAccumulateurKO"
import { checkExistValuesForm } from "src/shared/utils/helpers"
import { TERME_ACCUMULATEUR_KO_default } from "./default/TermeAccumulateurKO"
import { axisConfig } from "./config/AxisConfig"
import { CHART_STYLES } from "./config/ChartStyles"
import { ProdcutType } from "src/type/product"

const styles = CHART_STYLES[ProdcutType.TERME_ACCUMULATEUR_KO]

const defaultConfig = axisConfig("Cours au fixing", "Cours de couverture")

const TERME_ACCUMULATEUR_KO_import_chart = form => ([
    {
        type: "line",
        key: "borne-basse",
        data: [
            {x: form.borne_basse, y:form.borne_basse* 0.95},
            {x:form.borne_basse, y:form.strike}
        ],
        color: styles.borne_basse.color,
        strokeDasharray: styles.borne_basse.strokeDasharray,
        strokeWidth: styles.borne_basse.strokeWidth,

    },
    {
        type: "line",
        key: "montant-min-1",
        data: [
            {x: form.borne_basse, y: form.strike}, 
            {x: form.borne_haute, y: form.strike}
        ],
        color: styles.montant_min.color,
        strokeWidth: styles.montant_min.strokeWidth,
    },
    {
        type: "line",
        key: "borne-haute",
        data: [
                {x: form.borne_haute, y:form.borne_basse* 0.95},
            {x:form.borne_haute, y:form.strike}
            ],
        color: styles.borne_haute.color,
        strokeDasharray: styles.borne_haute.strokeDasharray,
        strokeWidth: styles.borne_haute.strokeWidth,

    },
    {
        type: "line",
        key: "montant-max-1",
        data: [
            {x: form.borne_haute, y: form.strike}, 
            {x: form.borne_haute* 1.05, y: form.strike}
        ],
        color: styles.montant_max.color,
        strokeWidth: styles.montant_max.strokeWidth,
    },
    {
        type: "line",
        key: "cours-a-terme",
        data: [
            {x: form.borne_basse*0.95, y: form.cours_a_terme}, 
            {x: form.borne_haute* 1.05, y: form.cours_a_terme}
        ],
        color: styles.cours_a_terme.color,
        strokeDasharray: styles.cours_a_terme.strokeDasharray,
        strokeWidth: styles.cours_a_terme.strokeWidth,
    },
    {
        type: "line",
        key: "support",     
        data: [
            {x: form.borne_basse*0.95, y:  form.cours_a_terme*1.1},
            {x: form.borne_haute*1.05, y:  form.cours_a_terme*1.1}
        ],                
        strokeWidth: 0
    },
    { 
        type: "point",
        key: "strike-1",
        data: [
            {x: form.borne_basse* 0.95, y: form.strike}
        ],
        color: styles.strike.color,
        caption: `Strike : ${form.strike}`
    },
    {
        type: "point",
        key: "borne-basse-point",
        data: [{x: form.borne_basse, y:form.borne_basse* 0.95}],
        color: styles.borne_basse.color,
        caption: `Borne basse : ${form.borne_basse}`
    },
    {
        type: "point",
        key: "borne-haute-point",
        data: [{x: form.borne_haute, y:form.borne_basse* 0.95}],
        color: styles.borne_haute.color,
        caption: `Borne haute : ${form.borne_haute}`
    }
])

const TERME_ACCUMULATEUR_KO_export_chart = form => ([
    {
        type: "line",
        key: "montant-max-1",
        data: [
            {x: form.borne_basse* 0.95, y: form.strike}, 
            {x: form.borne_basse, y: form.strike}
        ],
        color: styles.montant_max.color,
        strokeWidth: styles.montant_max.strokeWidth,
    }, 
    {
        type: "line",
        key: "borne-basse",
        data: [
            {x: form.borne_basse, y:form.borne_basse* 0.95},
            {x:form.borne_basse, y:form.strike}
        ],
        color: styles.borne_basse.color,
        strokeDasharray: styles.borne_basse.strokeDasharray,
        strokeWidth: styles.borne_basse.strokeWidth,

    },
    {
        type: "line",
        key: "montant-min-1",
        data: [
            {x: form.borne_basse, y: form.strike}, 
            {x: form.borne_haute, y: form.strike}
        ],
        color: styles.montant_min.color,
        strokeWidth: styles.montant_min.strokeWidth,
    },
    {
        type: "line",
        key: "borne-haute",
        data: [
            {x: form.borne_haute, y:form.borne_basse* 0.95},
            {x:form.borne_haute, y:form.strike}
        ],
        color: styles.borne_haute.color,
        strokeDasharray: styles.borne_haute.strokeDasharray,
        strokeWidth: styles.borne_haute.strokeWidth,
    },
    {
        type: "line",
        key: "cours-a-terme",
        data: [
            {x: form.borne_basse*0.95, y: form.cours_a_terme}, 
            {x: form.borne_haute* 1.05, y: form.cours_a_terme}
        ],
        color: styles.cours_a_terme.color,
        strokeDasharray: styles.cours_a_terme.strokeDasharray,
        strokeWidth: styles.cours_a_terme.strokeWidth,
    },
    {
        type: "line",
        key: "support",     
        data: [
            {x: form.borne_basse*0.95, y:  form.cours_a_terme*1.1},
            {x: form.borne_haute*1.05, y:  form.cours_a_terme*1.1}
        ],                
        strokeWidth: 0
    },
    { 
        type: "point",
        key: "strike-1",
        data: [
            {x: form.borne_basse* 0.95, y: form.strike}
        ],
        color: styles.strike.color,
        caption: `Strike : ${form.strike}`
    },
    {
        type: "point",
        key: "borne-basse-point",
        data: [{x: form.borne_basse, y:form.borne_basse* 0.95}],
        color: styles.borne_basse.color,
        caption: `Borne basse : ${form.borne_basse}`

    },
    {
        type: "point",
        key: "borne-haute-point",
        data: [{x: form.borne_haute, y:form.borne_basse* 0.95}],
        color: styles.borne_haute.color,
        caption: `Borne haute : ${form.borne_haute}`
    },
])

export const TERME_ACCUMULATEUR_KO_data = (form) => ([
    {
        option: "1",
        label: "Profil à chaque fixing (si import)",
        chart: TERME_ACCUMULATEUR_KO_import_chart(form),
        chartDefault: TERME_ACCUMULATEUR_KO_import_chart(TERME_ACCUMULATEUR_KO_default[0]),
        describe: TERME_ACCUMULATEUR_KO_import_payoffInfo(form),
        legends: {
            lines: [
                {title: "Montant max",      color: styles.montant_max.color,    strokeWidth: styles.montant_max.strokeWidth},
                {title: "Montant min",      color: styles.montant_min.color,    strokeWidth: styles.montant_min.strokeWidth}, 
                {title: "Cours à terme",    color: styles.cours_a_terme.color,  strokeWidth: styles.cours_a_terme.strokeWidth, strokeDasharray: styles.cours_a_terme.strokeDasharray}
            ],
            points: [
                {title: "Strike",           color: styles.strike.color},
                {title: "Borne basse",      color: styles.borne_basse.color},
                {title: "Borne haute",      color: styles.borne_haute.color},
            ]
        },
        config: defaultConfig,
        condition: checkExistValuesForm(form, ["strike"]),
        isAvailable: form.sens === "import" && form.ko === undefined
    },
    {
        option: "2",
        label: "Profil à chaque fixing (si export)",
        chart: TERME_ACCUMULATEUR_KO_export_chart(form),
        chartDefault: TERME_ACCUMULATEUR_KO_export_chart(TERME_ACCUMULATEUR_KO_default[1]),
        describe: TERME_ACCUMULATEUR_KO_export_payoffInfo(form),
        legends: {
            lines: [
                {title: "Montant max",      color: styles.montant_max.color,    strokeWidth: styles.montant_max.strokeWidth},
                {title: "Montant min",      color: styles.montant_min.color,    strokeWidth: styles.montant_min.strokeWidth}, 
                {title: "Cours à terme",    color: styles.cours_a_terme.color,  strokeWidth: styles.cours_a_terme.strokeWidth, strokeDasharray: styles.cours_a_terme.strokeDasharray}
            ],
            points: [
                {title: "Strike",           color: styles.strike.color},
                {title: "Borne basse",      color: styles.borne_basse.color},
                {title: "Borne haute",      color: styles.borne_haute.color},
            ]
        },
        config: defaultConfig,
        condition: checkExistValuesForm(form, ["strike"]),
        isAvailable: form.sens === "export" && form.ko === undefined
    },
    {
        option: "3",
        label: "Profil à chaque fixing (si import et barrière américaine non touchée)",
        chart: TERME_ACCUMULATEUR_KO_import_chart(form),
        chartDefault: TERME_ACCUMULATEUR_KO_import_chart(TERME_ACCUMULATEUR_KO_default[0]),
        describe: TERME_ACCUMULATEUR_KO_import_payoffInfo(form),
        legends: {
            lines: [
                {title: "Montant max",      color: styles.montant_max.color,    strokeWidth: styles.montant_max.strokeWidth},
                {title: "Montant min",      color: styles.montant_min.color,    strokeWidth: styles.montant_min.strokeWidth}, 
                {title: "Cours à terme",    color: styles.cours_a_terme.color,  strokeWidth: styles.cours_a_terme.strokeWidth, strokeDasharray: styles.cours_a_terme.strokeDasharray}
            ],
            points: [
                {title: "Strike",           color: styles.strike.color},
                {title: "Borne basse",      color: styles.borne_basse.color},
                {title: "Borne haute",      color: styles.borne_haute.color},
            ]
        },
        config: defaultConfig,
        condition: checkExistValuesForm(form, ["strike"]),
        isAvailable: form.sens === "import" && form.ko !== undefined
    },
    {
        option: "4",
        label: "Profil à chaque fixing (si export et barrière américaine non touchée)",
        chart: TERME_ACCUMULATEUR_KO_export_chart(form),
        chartDefault: TERME_ACCUMULATEUR_KO_export_chart(TERME_ACCUMULATEUR_KO_default[1]),
        describe: TERME_ACCUMULATEUR_KO_export_payoffInfo(form),
        legends: {
            lines: [
                {title: "Montant max",      color: styles.montant_max.color,    strokeWidth: styles.montant_max.strokeWidth},
                {title: "Montant min",      color: styles.montant_min.color,    strokeWidth: styles.montant_min.strokeWidth}, 
                {title: "Cours à terme",    color: styles.cours_a_terme.color,  strokeWidth: styles.cours_a_terme.strokeWidth, strokeDasharray: styles.cours_a_terme.strokeDasharray},
            ],
            points: [
                {title: "Strike",           color: styles.strike.color},
                {title: "Borne basse",      color: styles.borne_basse.color},
                {title: "Borne haute",      color: styles.borne_haute.color},
            ]
        },
        config: defaultConfig,
        condition: checkExistValuesForm(form, ["strike"]),
        isAvailable: form.sens === "export" && form.ko !== undefined
    },
    {
        option: "5",
        label: "Profil à chaque fixing (si import et barrière américaine touchée)",
        chart: "Les accumulations s'arrêtent et vous conservez vos accumulations précédentes",
        chartDefault: "Les accumulations s'arrêtent et vous conservez vos accumulations précédentes",
        config: defaultConfig,
        condition: true,
        isAvailable: form.sens === "import" && form.ko !== undefined
    },
    {
        option: "6",
        label: "Profil à chaque fixing (si export et barrière américaine touchée)",
        chart: "Les accumulations s'arrêtent et vous conservez vos accumulations précédentes",
        chartDefault: "Les accumulations s'arrêtent et vous conservez vos accumulations précédentes",
        config: defaultConfig,
        condition: true,
        isAvailable: form.sens === "export" && form.ko !== undefined
    },
])


// WEBPACK FOOTER //
// ./src/shared/Cotation/chart/data/TermeAccumulateurKO.tsx